import { useState, useEffect } from 'react'
import * as AWS from '../constants/aws.constant'
import axios from 'axios'

export default (config: any, inputs: ReadonlyArray<any> = []) => {
  const [isLoading, setLoading] = useState(false)
  const [response, setResponse] = useState<any>()
  const [error, setError] = useState()

  const request = async () => {
    setLoading(true)
    try {
      const API_BASE_URL = String(process.env.REACT_APP_MOFF_API_URL)

      const userPool = AWS.userPool()
      const cognitoUser = userPool.getCurrentUser()
      if (cognitoUser === null) {
        return null
      }
      let someConfig = {
        baseURL: API_BASE_URL,
        ...config,
      }
      let error
      let session
      await cognitoUser.getSession((e: any, s: any) => {
        if (e) {
          error = e
        }
        session = s
      })
      if (error) throw new Error(error)
      if (session) {
        const { data: response } = await axios({
          headers: {
            Authorization: session.getIdToken().getJwtToken(),
          },
          ...someConfig,
        })
        setResponse(response)
      } else {
        throw new Error('undefined')
      }
    } catch (e) {
      setError(e)
    } finally {
      setLoading(false)
    }
  }

  useEffect(
    () => {
      request()
    },
    [] // eslint-disable-line
  )
  return { isLoading, response, error, setResponse }
}



// WEBPACK FOOTER //
// ./src/hooks/use-fetch-api.ts